var map = {
	"./bg.png": 6726,
	"./closed-park-active.png": 7332,
	"./closed-park.png": 9811,
	"./common-system-active.png": 8241,
	"./common-system.png": 5695,
	"./double-prevention-active.png": 1671,
	"./double-prevention.png": 9104,
	"./hazard-web-active.png": 1894,
	"./hazard-web.png": 7234,
	"./majorHazard-active.png": 7930,
	"./majorHazard.png": 305,
	"./safe-production-active.png": 4139,
	"./safe-production.png": 263,
	"./special-work-active.png": 4589,
	"./special-work.png": 4529,
	"./title-bg.png": 5022,
	"./wisdom-emergency-active.png": 210,
	"./wisdom-emergency.png": 2692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5078;